import React from "react";
import { Navigate, useLocation, Route } from "react-router-dom";
import AdminFooter from "../src/components/Common/AdminFooter";
import AdminHeader from "../src/components/Common/AdminHeader";
import AdminSideBar from "../src/components/Common/AdminSideBar";

const ProtectedRoute = ({ children }) => {
  
  // const user = useSelector((state) => state.user);
  let location = useLocation();
    
  if (!sessionStorage.getItem("user")) {
    return <Navigate to={{pathname:"/", props: "data"}} state={{ from: location }} replace />;
  }
  return (
    <>
      {window.location.href.includes("access") || window.location.href.includes("Map") ? (
        children
      ) : (
        <>
         
          {window.location.href.includes("MNT") || window.location.href.includes("Powerbi") ? "" : <AdminHeader />}
          {window.location.href.includes("inspection") || window.location.href.includes("/bhuwannewgen")|| window.location.href.includes("/map")|| window.location.href.includes("/gisdashboard") || window.location.href.includes("AdminAccess")  || window.location.href.includes("SchemeReports") || window.location.href.includes("nfsmscheme")|| window.location.href.includes("nmeoscheme")||window.location.href.includes("nmeoscheme3f") || window.location.href.includes("NFSMCFLDWiseReport") || window.location.href.includes("NFSMFarmersOutcomesUploadedReport") || window.location.href.includes("Analytics") || window.location.href.includes("farmerandcropwisereport")  || window.location.href.includes("pdmcanalytic") || window.location.href.includes("naturalfarminganalytic") || window.location.href.includes("Powerbi") || window.location.href.includes("MNT") ? "" :  
          <AdminSideBar />}     
          
          {children}
          {/* <AdminFooter /> */}
        </>
      )}
    </>
  );
};

export default ProtectedRoute;
